import React from "react";
import AdminNavbar from "../Layout/AdminNavbar";
import EmailTemplatesPage from "../placement/EmailTemplatesPage";

export default function EmailTemplatesAdminPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <AdminNavbar />
      <EmailTemplatesPage />
    </div>
  );
}
